import React from "react";

interface ProgressBarProps {
  value: number;
  className?: string;
  colorClassName?: string;
}

export function ProgressBar({ value, className = "", colorClassName }: ProgressBarProps) {
  const clamped = Math.min(100, Math.max(0, value));
  const barColor =
    colorClassName ??
    (clamped >= 80
      ? "bg-emerald-500"
      : clamped >= 50
      ? "bg-amber-500"
      : "bg-primary-500");

  return (
    <div
      className={`h-2 w-full rounded-full bg-slate-100 dark:bg-slate-700 overflow-hidden ${className}`}
    >
      <div
        className={`h-full rounded-full transition-all duration-500 ${barColor}`}
        style={{ width: `${clamped}%` }}
      />
    </div>
  );
}
